import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CranksetHardware from '@/components/setup/crankset/CranksetHardware.vue'
import HandlebarHardware from '@/components/setup/handlebar/HandlebarHardware.vue'
import PedalHardware from '@/components/setup/pedal/PedalHardware.vue'
import SaddleHardware from '@/components/setup/saddle/SaddleHardware.vue'
import { BfFlex } from '@finetic/bikefitting-ui'

export default /*@__PURE__*/_defineComponent({
  __name: 'CurrentHardware',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfFlex), {
    direction: "column",
    gap: "0.8rem"
  }, {
    default: _withCtx(() => [
      _createVNode(SaddleHardware),
      _createVNode(HandlebarHardware),
      _createVNode(CranksetHardware),
      _createVNode(PedalHardware)
    ]),
    _: 1
  }))
}
}

})